"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const errors_1 = require("../../errors");
const IChargeTier_1 = require("../models/rates/IChargeTier");
const ICondition_1 = require("../models/rates/ICondition");
const ConditionValidator_1 = __importDefault(require("./ConditionValidator"));
const GroupingAndMinimumsValidator_1 = __importDefault(require("./GroupingAndMinimumsValidator"));
class RateDetailValidator {
    constructor(groupingAndMinimumsValidator, conditionValidator) {
        this._groupingAndMinimumsValidator = groupingAndMinimumsValidator
            ? groupingAndMinimumsValidator
            : new GroupingAndMinimumsValidator_1.default();
        this._conditionValidator = conditionValidator
            ? conditionValidator
            : new ConditionValidator_1.default();
    }
    _groupingAndMinimumsValidator;
    _conditionValidator;
    _schema = joi_1.default.object({
        conditions: joi_1.default.array().required(),
        groupingAndMins: joi_1.default.object().required(),
    });
    shipping = {
        validate: (input, isUomCountRate) => {
            let groupingAndMinsIssues = [];
            const rateDetailIssues = [];
            const conditionIssues = [];
            rateDetailIssues.push(...(this.validateRateDetail(input, '$') ?? []));
            if (!input.groupingAndMins) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailError.addIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, 'groupingAndMins', undefined, '');
                throw rateDetailError;
            }
            else {
                groupingAndMinsIssues =
                    this._groupingAndMinimumsValidator.validate(input.groupingAndMins, `$groupingAndMins`);
            }
            if (!input.conditions || input.conditions.length == 0) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailError.addIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, 'conditions', undefined, '');
                throw rateDetailError;
            }
            else {
                input.conditions?.forEach((condition, index) => {
                    const issue = this._conditionValidator.shipping.validate(condition, `$conditions[${index}]`, isUomCountRate);
                    if (issue?.length && issue?.length > 0) {
                        conditionIssues?.push(...issue);
                    }
                });
            }
            rateDetailIssues.push(...conditionIssues, ...(groupingAndMinsIssues ?? []));
            if (rateDetailIssues.length > 0) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailIssues.forEach((issue) => {
                    rateDetailError.addIssue(issue.modelType, issue.errorCode, issue.fieldName, issue.value, issue.path);
                });
                throw rateDetailError;
            }
        },
    };
    receiving = {
        validate: (input, isUomCountRate) => {
            let groupingAndMinsIssues = [];
            const rateDetailIssues = [];
            const conditionIssues = [];
            rateDetailIssues.push(...(this.validateRateDetail(input, '$') ?? []));
            if (!input.groupingAndMins) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailError.addIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, 'groupingAndMins', undefined, '');
                throw rateDetailError;
            }
            else {
                groupingAndMinsIssues =
                    this._groupingAndMinimumsValidator.validate(input.groupingAndMins, `$groupingAndMins`);
            }
            if (!input.conditions || input.conditions.length == 0) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailError.addIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, 'conditions', undefined, '');
                throw rateDetailError;
            }
            else {
                input.conditions?.forEach((condition, index) => {
                    const issue = this._conditionValidator.receiving.validate(condition, `$conditions[${index}]`, isUomCountRate);
                    if (issue?.length && issue?.length > 0) {
                        conditionIssues?.push(...issue);
                    }
                });
            }
            rateDetailIssues.push(...conditionIssues, ...(groupingAndMinsIssues ?? []));
            if (rateDetailIssues.length > 0) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailIssues.forEach((issue) => {
                    rateDetailError.addIssue(issue.modelType, issue.errorCode, issue.fieldName, issue.value, issue.path);
                });
                throw rateDetailError;
            }
        },
    };
    returns = {
        validate: (input, isUomCountRate) => {
            let groupingAndMinsIssues = [];
            const rateDetailIssues = [];
            const conditionIssues = [];
            rateDetailIssues.push(...(this.validateRateDetail(input, '$') ?? []));
            if (!input.groupingAndMins) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailError.addIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, 'groupingAndMins', undefined, '');
                throw rateDetailError;
            }
            else {
                groupingAndMinsIssues =
                    this._groupingAndMinimumsValidator.validate(input.groupingAndMins, `$groupingAndMins`);
            }
            if (!input.conditions || input.conditions.length == 0) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailError.addIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, 'conditions', undefined, '');
                throw rateDetailError;
            }
            else {
                input.conditions?.forEach((condition, index) => {
                    const issue = this._conditionValidator.returns.validate(condition, `$conditions[${index}]`, isUomCountRate);
                    if (issue?.length && issue?.length > 0) {
                        conditionIssues?.push(...issue);
                    }
                });
            }
            rateDetailIssues.push(...conditionIssues, ...(groupingAndMinsIssues ?? []));
            if (rateDetailIssues.length > 0) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailIssues.forEach((issue) => {
                    rateDetailError.addIssue(issue.modelType, issue.errorCode, issue.fieldName, issue.value, issue.path);
                });
                throw rateDetailError;
            }
        },
    };
    adjustments = {
        validate: (input, isUomCountRate) => {
            let groupingAndMinsIssues = [];
            const rateDetailIssues = [];
            const conditionIssues = [];
            rateDetailIssues.push(...(this.validateRateDetail(input, '$') ?? []));
            if (!input.groupingAndMins) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailError.addIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, 'groupingAndMins', undefined, '');
                throw rateDetailError;
            }
            else {
                groupingAndMinsIssues =
                    this._groupingAndMinimumsValidator.validate(input.groupingAndMins, `$groupingAndMins`);
            }
            if (!input.conditions || input.conditions.length == 0) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailError.addIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, 'conditions', undefined, '');
                throw rateDetailError;
            }
            else {
                input.conditions?.forEach((condition, index) => {
                    const issue = this._conditionValidator.adjustments.validate(condition, `$conditions[${index}]`, isUomCountRate);
                    if (issue?.length && issue?.length > 0) {
                        conditionIssues?.push(...issue);
                    }
                });
            }
            rateDetailIssues.push(...conditionIssues, ...(groupingAndMinsIssues ?? []));
            if (rateDetailIssues.length > 0) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailIssues.forEach((issue) => {
                    rateDetailError.addIssue(issue.modelType, issue.errorCode, issue.fieldName, issue.value, issue.path);
                });
                throw rateDetailError;
            }
        },
    };
    assemblies = {
        validate: (input, isUomCountRate) => {
            let groupingAndMinsIssues = [];
            const rateDetailIssues = [];
            const conditionIssues = [];
            rateDetailIssues.push(...(this.validateRateDetail(input, '$') ?? []));
            if (!input.groupingAndMins) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailError.addIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, 'groupingAndMins', undefined, '');
                throw rateDetailError;
            }
            else {
                groupingAndMinsIssues =
                    this._groupingAndMinimumsValidator.validate(input.groupingAndMins, `$groupingAndMins`);
            }
            if (!input.conditions || input.conditions.length == 0) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailError.addIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, 'conditions', undefined, '');
                throw rateDetailError;
            }
            else {
                input.conditions?.forEach((condition, index) => {
                    const issue = this._conditionValidator.assemblies.validate(condition, `$conditions[${index}]`, isUomCountRate);
                    if (issue?.length && issue?.length > 0) {
                        conditionIssues?.push(...issue);
                    }
                });
            }
            rateDetailIssues.push(...conditionIssues, ...(groupingAndMinsIssues ?? []));
            if (rateDetailIssues.length > 0) {
                const rateDetailError = new errors_1.Errors.ValidationError();
                rateDetailIssues.forEach((issue) => {
                    rateDetailError.addIssue(issue.modelType, issue.errorCode, issue.fieldName, issue.value, issue.path);
                });
                throw rateDetailError;
            }
        },
    };
    factory(isSimple, isFlat) {
        const defaultChargeTiers = {
            type: IChargeTier_1.TierType.Absolute,
            resetBy: undefined,
            tiers: [],
            chargeMinimumAmount: undefined,
        };
        const defaultConditions = [];
        const rateDetailFrame = {
            conditions: [],
            groupingAndMins: {
                groupChargesBy: undefined,
                minimumChargeAmount: undefined,
                applyMinimumToGroup: undefined,
            },
        };
        if (isFlat) {
            defaultChargeTiers.tiers.push({
                operator: IChargeTier_1.TierOperators.Noop,
                from: 0,
                to: undefined,
                chargeAmount: undefined,
            });
        }
        else {
            defaultChargeTiers.type = undefined;
            defaultChargeTiers.tiers.push({
                operator: IChargeTier_1.TierOperators.LessThanOrEqual,
                from: 1,
                to: undefined,
                chargeAmount: undefined,
            }, {
                operator: IChargeTier_1.TierOperators.GreaterThan,
                from: 1,
                to: undefined,
                chargeAmount: undefined,
            });
        }
        if (isSimple) {
            defaultConditions.push({
                condition: {
                    opType: ICondition_1.DataOperatorType.logicOperator,
                    operation: ICondition_1.ConditionalOperations.noop,
                    operands: [],
                },
                chargeMethod: {
                    chargeType: undefined,
                    countingUnit: undefined,
                    calculatedBy: undefined,
                    roundUp: undefined,
                },
                chargeTiers: defaultChargeTiers,
            });
        }
        else {
            defaultConditions.push({
                condition: {
                    opType: undefined,
                    operation: undefined,
                    operands: [],
                },
                chargeMethod: {
                    chargeType: undefined,
                    countingUnit: undefined,
                    calculatedBy: undefined,
                    roundUp: undefined,
                },
                chargeTiers: defaultChargeTiers,
            });
        }
        rateDetailFrame.conditions = defaultConditions;
        return rateDetailFrame;
    }
    validateRateDetail(rateDetail, jsonPath) {
        const results = this._schema.validate(rateDetail, {
            abortEarly: false,
            convert: false,
        });
        if (results.error) {
            const issues = [];
            results.error.details.forEach((issue) => {
                switch (issue.type) {
                    case 'any.only': {
                        issues.push(new errors_1.Errors.ValidationIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.invalidValue, issue.context?.key, issue.context?.value, jsonPath));
                        break;
                    }
                    case 'any.required': {
                        issues.push(new errors_1.Errors.ValidationIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.requiredValue, issue.context?.key, undefined, jsonPath));
                        break;
                    }
                    case 'object.unknown': {
                        issues.push(new errors_1.Errors.ValidationIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.notAllowed, issue.context?.key, issue.context?.value, jsonPath));
                        break;
                    }
                    case 'object.base': {
                        issues.push(new errors_1.Errors.ValidationIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.invalidType, undefined, issue.context?.value, jsonPath));
                        break;
                    }
                    case 'array.base': {
                        issues.push(new errors_1.Errors.ValidationIssue('IRateDetail', errors_1.Errors.ValidationErrorCode.invalidType, issue.context?.key, issue.context?.value, jsonPath));
                        break;
                    }
                }
            });
            return issues;
        }
    }
}
exports.default = RateDetailValidator;
